import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { Variant } from '../types'

export const getDisabledStyle = (variant: Variant): SerializedStyles => css`
  &:disabled {
    background-color: ${Color.Grey100};
    color: ${Color.Grey400};
    box-shadow: ${variant === 'outlined' ? `inset 0 0 0 1px ${Color.Grey200}` : 'none'};
    cursor: not-allowed;
  }
`
